<template>
  <div class="simplecast-playlist">
    <Main :store="store" />
  </div>
</template>

<script>
import Main from './PlaylistMain'
import Store from '../store'

export default {
  components: {
    Main
  },
  props: {
    color: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    websocket: {
      type: String,
      default: ''
    }
  },
  data () {
    return { store: new Store() }
  },
  computed: {
    podcast () { return this.store.state.podcast }
  },
  watch: {
    color (color) {
      this.store.setColor(color)
    },
    podcast (val) {
      if (this.podcast.distribution_channels && this.podcast.distribution_channels.href) {
        this.store.getDistributionChannels(this.podcast.distribution_channels.href)
      }
    }
  },
  created () {
    this.store.openWebsocket(this.websocket)
    this.store.setIsDark(this.dark)
    this.store.setColor(this.color)

    if (this.id !== '') {
      this.store.getPlaylist(this.id)
    } else {
      this.store.setIsLoaded(true)
      console.error('A show ID needs to be set. You have not set one (╯°□°)╯︵ ┻━┻')
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_components/ratios.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/faces.scss';

/* NOTE
html is set to 87.5% so that all the REM measurements throughout Skeleton
are based on 14px sizing. So basically 1rem = 14px :) */
html, body {
  color: $black-800;
  font-size: 87.5%;

  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
}
</style>

<style lang="scss" scoped>
.simplecast-playlist {
  height: 100%;
  position: relative;
}
</style>
